module.exports = "pegasus/assets/themelp1/small/40.png";